(function () {
  'use strict';

  angular
    .module('app.paperworkforms', []);

})();